import { ISharePanel } from '@models/ISharePanel';
import SharePanel from '@molecules/SharePanel/SharePanel';

const ArticleShare = (props: ISharePanel) => (
  <section>
    {/* //! TODO: Need aria-label values passing to share panel (share to Facebook, Twitter, etc.) */}
    <SharePanel {...props} />
  </section>
);

export default ArticleShare;
